<template>
    <router-link v-if="link.length > 0" :to="link" class="btn">{{ text }}</router-link>
    <button v-else type="button" class="btn" @click="buttonClicked">{{ text }}</button>
</template>

<script>
    // import { S3Client, HeadObjectCommand } from "@aws-sdk/client-s3"

    export default {
        name: 'AppButton',
        props: {
            text: {
                type: String,
                required: true
            },
            link: {
                type: String,
                default: ''
            },
            from: {
                type: String,
                required: false
            },
            user_id: {
                type: Number,
                required: false
            },
            search_token: {
                type: Number,
                required: false
            },
            job_type:{
                type: Array,
                required: false
            },
            trademark_cat:{
                type: Array,
                required: false
            },
            report_cat: {
                type: String,
                required: false
            },
            keyword: {
                type: String,
                required: false
            },
            konstruktorSearchId: {
                type: String,
                required: false
            },
            konstruktorName: {
                type: String,
                required: false
            }
        },

        methods: {
            async buttonClicked() {
                // if(this.from === 'webreport'){
                //     // alert(this.search_token)
                //     const config = {
                //         credentials:{
                //             accessKeyId: "AKIA3C5S3AOJ3WFJN5BS",
                //             secretAccessKey: "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",
                //         },

                //         region: "eu-west-3",
                //         version: "latest"
                //     }
                //     const input = {
                //         Bucket: 'khonsuwebscreenshot',
                //         Key:  this.keyword.replaceAll("https://", "").replaceAll("www.","").replaceAll(".com","").replaceAll("/","") + '.jpg'
                //     }
                //     const client = new S3Client(config)
                //     const command = new HeadObjectCommand(input)
                //     const response = await client.send(command)
                //     if(response.$metadata.httpStatusCode ===200){
                //         window.open('https://khonsuwebscreenshot.s3.eu-west-3.amazonaws.com/' + this.keyword.replaceAll("https://", "").replaceAll("www.","").replaceAll(".com","").replaceAll("/","") + '.jpg', '_blank').focus();

                //     }else {
                //         alert("Screenshot not ready")
                //     }

                // }
                if (this.from === 'dekonstrukt_reportor_back') {
                    this.$emit('btnType:view', {type: 'dekonstruktor_dashboard'});
                }
                if (this.from === 'dekonstruktor_summary_history_back') {
                    this.$emit('btnType:view', {type: 'dekonstruktor_summary_history'});
                }
                if (this.from === 'dekonstruktor_summary_back') {
                    this.$emit('btnType:view', {type: 'dekonstruktor_summary'});
                }
                if (this.from === 'dekonstruktor_type_back') {
                    this.$emit('btnType:view', {type: 'dekonstruktor_type'});
                }
                if (this.from === 'dekonstruktor_category_back') {
                    this.$emit('btnType:view', {type: 'dekonstruktor_category'});
                }
                if (this.from === 'dekonstruktor_search_back') {
                    this.$emit('btnType:view', {type: 'dekonstruktor_search'});
                }
                if (this.from === 'dekonstruktor_view_report') {

                    await this.$store.dispatch('BrandDeKonstrucktor/getSearchCountValues', {
                        'user_id': this.user_id,
                        'keyword': this.keyword,
                        'search_token': this.search_token,
                        'jobType': this.job_type,
                        "trademark_cat": this.trademark_cat
                    }).then(response => {
                        //user selected keyword and search token from hostory page
                          sessionStorage.setItem('_keyword',this.keyword);
                          sessionStorage.setItem('_search_token',this.search_token);

                        //domain Counts
                        if (this.job_type.includes('domain_search')) {
                            this.$store.state.BrandDeKonstrucktorSearching.domainSearchCount = response.data.domainCount?.domain_count;
                            this.$store.state.BrandDeKonstrucktorSearching.domainfreeSearchCount = response.data.domainCount?.free_domain_count;
                            this.$store.state.BrandDeKonstrucktorMain.preloader_inner_domainSearch = response.data.domainCount?.percentage_complete;
                        }
                        //web Counts
                        if (this.job_type.includes('web_search')) {
                            this.$store.state.BrandDeKonstrucktorSearching.webSearchCount = response.data.webCount?.web_count;
                            this.$store.state.BrandDeKonstrucktorMain.preloader_inner_webSearch = response.data.webCount?.percentage_complete;
                        }
                        //social
                        if (this.job_type.includes('social_search')) {
                            this.$store.state.BrandDeKonstrucktorSearching.socialSearchCount = response.data.socialCount?.social_media_count;
                            this.$store.state.BrandDeKonstrucktorMain.preloader_inner_socialSearch = response.data.socialCount?.percentage_complete;
                        }
                        //trademark Counts
                        if (this.job_type.includes('trademark_search')) {
                                //---------------------------
                                this.$store.state.BrandDeKonstrucktorSearching.unitedkingdomTrademarkSearchCount = response.data.trademarkCount?.uktrademark_count;
                                if (response.data.trademarkCount?.request_status === 0) {
                                    this.$store.state.BrandDeKonstrucktorSearching.uksearchAvailable = false
                                }
                                if (response.data.trademarkCount?.request_status === 1) {
                                    this.$store.state.BrandDeKonstrucktorSearching.uksearchAvailable = true
                                }
                                this.$store.state.BrandDeKonstrucktorSearching.europeTrademarkSearchCount = response.data.eutrademarkCount?.europetrademark_count;
                                if (response.data.eutrademarkCount?.request_status === 0) {
                                    this.$store.state.BrandDeKonstrucktorSearching.europesearchAvailable = false
                                }
                                if (response.data.eutrademarkCount?.request_status === 1) {
                                    this.$store.state.BrandDeKonstrucktorSearching.europesearchAvailable = true
                                }
                                this.$store.state.BrandDeKonstrucktorMain.preloader_inner_trademarkSearch = parseInt(response.data.trademarkCount?.percentage_complete) + parseInt(response.data.eutrademarkCount?.percentage_complete)

                            }

                    });


                    this.$store.dispatch('BrandDeKonstrucktorSearching/userSelectedSearchCategory', {
                        'user_id': this.user_id,
                        'keyword': this.keyword,
                        'search_token': this.search_token
                    })
                    this.$store.dispatch('BrandDeKonstrucktor/getResultHistory', {
                        'user_id': this.user_id,
                        'keyword': this.keyword,
                        'search_token': this.search_token,
                        "trademark_cat": this.trademark_cat
                    });

                    this.$router.push('/brand-checker/historydekonstrukt');
                }
                if (this.from === 'dekonstruktor_history') {

                    this.$emit('btnType:view', {type: 'dekonstruktor_history', user_id: this.user_id});
                }
                if (this.from === 'dekonstruktor_start') {

                    this.$emit('btnType:view', {type: 'dekonstruktor_start', user_id: this.user_id});
                }


                if (this.from === 'konstruktor_result_back') {
                    this.$emit('btnType:view', {type: 'konstruktor_result'});
                }
                if (this.from === 'konstruktor_tool_back') {
                    this.$emit('btnType:view', {type: 'konstruktor_tool'});
                }
                if (this.from === 'konstruktor_word_filter_back') {
                    this.$emit('btnType:view', {type: 'konstruktor_word_filter'});
                }

                if (this.from === 'konstruktor_word_bank_back') {
                    this.$emit('btnType:view', {type: 'konstruktor_word_bank'});
                }
                if (this.from === 'konstruktor_project_name_back') {
                    this.$emit('btnType:view', {type: 'konstruktor_project_name'});
                }


                if (this.from === 'konstruktor_random_back') {
                    this.$emit('btnType:view', {type: 'konstruktor_random_words'});
                }

                if (this.from === 'konstruktor_view_report') {
                    this.$store.state.BrandKonstrucktorWordBank.konstruktorName = this.konstruktorName;

                    this.$store.state.BrandKonstrucktorWordBank.wordsbank = this.konstruktorSearchId.split(',');
                    this.$router.push('/brand-creator/savedkonstrukt');

                }

                if (this.from === 'all_dekonstruktor_view_report') {

                    this.$emit('btnType:view', {type: 'dekonstruktor_report', report_cat: this.report_cat});
                }


                if (this.from === 'konstruktor_history') {

                    this.$emit('btnType:view', {type: 'konstruktor_history', user_id: this.user_id});
                }


                if (this.from === 'konstruktor_start') {

                    this.$emit('btnType:view', {type: 'konstruktor_start', user_id: this.user_id});
                }


            }
        }
    }
</script>
